// removed by extract-text-webpack-plugin
module.exports = {"root":"_2K0BiN4th9KMh2_IlOcJHH","border":"ettRPETC3WenpSLUOwZDX","size-top-search":"_3e4GEFRaSinTlREdrq1ZeT","size-undefined":"_29vhqKvr0OfXtbSpJH_iwR","size-default":"CDizaY87yudXtdcWlRBHK","muhimma":"_1zZMS8DDk3OjRgOe-sBESi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/select.scss
// module id = 1172
// module chunks = 0